import { useI18n as vueUseI18n } from 'vue-i18n'

import { locales } from '@/i18n'

export const useI18n = () => {
  const { t, locale, n } = vueUseI18n()

  const setLocale = (newLocale) => {
    if (locales.includes(newLocale)) {
      locale.value = newLocale
      return true
    }
    return false
  }

  const getLocales = () => locales

  const getCurrentLocale = () => locale.value

  return {
    t,
    n,
    locale: getCurrentLocale(),
    setLocale,
    getLocales,
    getCurrentLocale,
  }
}

export default useI18n
